export default {
  bind(el, binding, vnode, oldVnode) {
    let openDelay = false
    el.onclick = function(e) {
      if (openDelay) return
      openDelay = !openDelay
      if (!binding.value) {
        alert('未传入Value数据！')
        return
      }
      const func = binding.value['func']
      const time = binding.value['time']
      if (typeof time !== 'number') {
        alert('传入等待时间错误')
        return
      }
      const args = []
      for (const key in binding.value) {
        if (binding.value.hasOwnProperty(key)) {
          if (key === 'func' || key === 'time') continue
          args.push(binding.value[key])
        }
      }
      setTimeout(() => {
        openDelay = !openDelay
      }, time)
      func(...args)
    }
  }
}
